import React, { Fragment } from 'react';
import '../loggedOut.css';

const InHomeSupport = () => {
    return (
        <Fragment>
            <div className="logged-out">
                <section className="service-hero scene scene--hero page-hero">
                    <div className="container">
                        <div className="hero-grid">
                            <div className="hero-copy">
                                <h1 className="display-5 mb-3">In home Support</h1>
                                <p className="lead">
                                    In home support was BCA's first natural evolution. Clientele were very happy with the community access program, which was the foundation upon BCA was founded.
                                </p>
                            </div>
                            <div className="hero-media text-center">
                                <div className="image-shell image-shell--hero">
                                    <img
                                        src="/marketing_images/home_support/1_top_pic.jpg"
                                        alt="In home support"
                                        className="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="service-content scene scene--paper story-band">
                    <div className="container">
                        <div className="story-card">
                            <p className="mb-4">
                                As demand increased for additional supports, clients started requesting support in the home.
                            </p>

                            <p className="mb-5">
                                Again, highly customisable, a support plan is developed with consultation from the client, caregivers, allied health and the support worker - which guides and governs the support to be provided. This ensures that our support closely targets an individual's goals.
                            </p>

                            <p className="mb-4">
                                Some of the supports provided to clients include:
                            </p>

                            <div className="row g-4">
                                {inHomeSupportServices.map((service) => (
                                    <div className="col-md-6 col-lg-4" key={service.title}>
                                        <div className="card h-100 border-0 shadow-sm rounded-4">
                                            <div className="image-shell image-shell--card">
                                                <img
                                                    src={service.image}
                                                    alt={service.title}
                                                    className="card-img-top rounded-top-4"
                                                />
                                            </div>
                                            <div className="card-body text-center">
                                                <p className="mb-0">{service.title}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                <section className="service-footer scene scene--soft py-6">
                    <div className="container text-center">
                        <div className="image-shell image-shell--wide">
                            <img
                                src="/marketing_images/home_support/2_bottom_pic.jpg"
                                alt="Comfortable and supported at home"
                                className="img-fluid"
                            />
                        </div>
                    </div>
                </section>
            </div>
        </Fragment>
    );

}

export default InHomeSupport;

const inHomeSupportServices = [
    {
        title: "Assistance cooking and meal preparation",
        image: "/marketing_images/home_support/assistance_cooking_and_meal_prepping.jpg",
    },
    {
        title: "Cleaning and Gardening services",
        image: "/marketing_images/home_support/cleaning_and_gardening.jpg",
    },
    {
        title: "Self-care and personal care",
        image: "/marketing_images/home_support/self_care_and_personal_care.jpg",
    },
    {
        title: "Assistance with appointments and errands",
        image: "/marketing_images/home_support/assistance_with_appointments_and_errands.jpg",
    },
    {
        title: "Life administration",
        image: "/marketing_images/home_support/life_administration.jpg",
    },
    {
        title: "Organisation and de-cluttering",
        image: "/marketing_images/home_support/organisation_and_de-cluttering.jpg",
    },
    {
        title: "Life skill building (in home)",
        image: "/marketing_images/home_support/life_skill_building_in_home.jpg",
    },
]
